module.exports = __webpack_public_path__ + "img/garancy.6842985e.webp";